<template>
  <section>
    <div v-if="obj" class="standardItem1">
      <div>{{ obj.title }}</div>
      <div>
        <span v-for="(item, index) in list" :key="index">
          <span v-if="item.type == 'text'">{{ item.label }}</span>
          <img
            v-if="item.type == 'img'"
            :src="require(`@/assets/icon/icon-${item.model}.png`)"
            alt=""
          >
          <span>{{ obj[item.model] }}</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoData1',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    handleRoute(v, x) {
      if (v == 5) {
        this.$router.push(x)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.standardItem1 {
  @include fun-layout(2);
  padding: 10px 20px;
  > div {
    &:nth-child(1) {
      font-family: "Microsoft YaHei";
      color: #333;
      font-weight: bold;
      text-align: center;
      font-size: 26px;
    }
    &:nth-child(2) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 19px;
      > span {
        font-family: "Microsoft YaHei";
        font-size: 14px;
        color: #999;
        line-height: 24px;
        margin-right: 22px;
      }
    }
    &:nth-child(3) {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 19px;
      width: 688px;
      > span {
        font-family: "Microsoft YaHei";
        font-size: 12px;
        color: #888;
        line-height: 24px;
        margin-right: 22px;
        img {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
